import {CorpusGroup, LearnerMoreGroup, LearnerToolsGroup} from '../groups';
import {LinkGroup} from 'shared/pretty-easy-navigation/models';
import {NavigationContext} from '../navigation.context';

export const LearnerExploreGroup = (context: NavigationContext): LinkGroup  => ({
    type: 'linkGroup',
    links: [
        CorpusGroup(context),
        LearnerToolsGroup(context),
        LearnerMoreGroup(context)
    ]
})